import {
  Companion_getInstance1z8if8hzu5ng5 as Companion_getInstance,
  CompletionMessageComment2phagw82v6lch as CompletionMessageComment,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_lineItem(_this__u8e3s4) {
  return _this__u8e3s4.prop(CompletionMessageComment_lineItem_getInstance());
}
function get_created(_this__u8e3s4) {
  return _this__u8e3s4.prop(CompletionMessageComment_created_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(CompletionMessageComment_project_getInstance());
}
function prepareCompletionMessageCommentFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [CompletionMessageComment__id_getInstance(), CompletionMessageComment_completionMessage_getInstance(), CompletionMessageComment_project_getInstance(), CompletionMessageComment_lineItem_getInstance(), CompletionMessageComment_sender_getInstance(), CompletionMessageComment_senderName_getInstance(), CompletionMessageComment_clientMessage_getInstance(), CompletionMessageComment_message_getInstance(), CompletionMessageComment_readBy_getInstance(), CompletionMessageComment_created_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function CompletionMessageComment_lineItem$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function CompletionMessageComment_lineItem$_get_name_$ref_o51469() {
  return (p0) => p0.k20();
}
function CompletionMessageComment_lineItem$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment_lineItem$_get_serializer_$ref_5t7g56() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment_lineItem$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function CompletionMessageComment_lineItem$_get_annotations_$ref_lzhpze() {
  return (p0) => p0.bz();
}
var CompletionMessageComment_lineItemClass;
function CompletionMessageComment_lineItem() {
  if (CompletionMessageComment_lineItemClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment_lineItem_instance = this;
        var tmp = this;
        tmp.l5d_1 = lazy(CompletionMessageComment_lineItem$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m5d_1 = lazy(CompletionMessageComment_lineItem$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n5d_1 = lazy(CompletionMessageComment_lineItem$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.l5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment_lineItem$_get_name_$ref_o51469(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.s5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      z5d(receiver, value) {
        return receiver.a5e(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.z5d(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment_lineItem$_get_serializer_$ref_5t7g56(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n5d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment_lineItem$_get_annotations_$ref_lzhpze(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment_lineItem', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment_lineItemClass = $;
  }
  return CompletionMessageComment_lineItemClass;
}
var CompletionMessageComment_lineItem_instance;
function CompletionMessageComment_lineItem_getInstance() {
  if (CompletionMessageComment_lineItem_instance === VOID)
    new (CompletionMessageComment_lineItem())();
  return CompletionMessageComment_lineItem_instance;
}
function CompletionMessageComment_created$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function CompletionMessageComment_created$_get_name_$ref_8wwwa() {
  return (p0) => p0.k20();
}
function CompletionMessageComment_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment_created$_get_serializer_$ref_t60svl() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment_created$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function CompletionMessageComment_created$_get_annotations_$ref_342ryt() {
  return (p0) => p0.bz();
}
var CompletionMessageComment_createdClass;
function CompletionMessageComment_created() {
  if (CompletionMessageComment_createdClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment_created_instance = this;
        var tmp = this;
        tmp.b5e_1 = lazy(CompletionMessageComment_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c5e_1 = lazy(CompletionMessageComment_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d5e_1 = lazy(CompletionMessageComment_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.e5e_1 = get_default(Companion_instance).d1m();
        this.f5e_1 = 'now()';
      }
      k20() {
        var tmp0 = this.b5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment_created$_get_name_$ref_8wwwa(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.y5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      g5e(receiver, value) {
        return receiver.a5e(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.g5e(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment_created$_get_serializer_$ref_t60svl(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment_created$_get_annotations_$ref_342ryt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment_created', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment_createdClass = $;
  }
  return CompletionMessageComment_createdClass;
}
var CompletionMessageComment_created_instance;
function CompletionMessageComment_created_getInstance() {
  if (CompletionMessageComment_created_instance === VOID)
    new (CompletionMessageComment_created())();
  return CompletionMessageComment_created_instance;
}
function CompletionMessageComment_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function CompletionMessageComment_project$_get_name_$ref_40cug5() {
  return (p0) => p0.k20();
}
function CompletionMessageComment_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment_project$_get_serializer_$ref_sf8lvm() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function CompletionMessageComment_project$_get_annotations_$ref_q6csxy() {
  return (p0) => p0.bz();
}
var CompletionMessageComment_projectClass;
function CompletionMessageComment_project() {
  if (CompletionMessageComment_projectClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment_project_instance = this;
        var tmp = this;
        tmp.h5e_1 = lazy(CompletionMessageComment_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i5e_1 = lazy(CompletionMessageComment_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j5e_1 = lazy(CompletionMessageComment_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.h5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment_project$_get_name_$ref_40cug5(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.r5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      z5d(receiver, value) {
        return receiver.a5e(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.z5d(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment_project$_get_serializer_$ref_sf8lvm(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment_project$_get_annotations_$ref_q6csxy(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment_project', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment_projectClass = $;
  }
  return CompletionMessageComment_projectClass;
}
var CompletionMessageComment_project_instance;
function CompletionMessageComment_project_getInstance() {
  if (CompletionMessageComment_project_instance === VOID)
    new (CompletionMessageComment_project())();
  return CompletionMessageComment_project_instance;
}
function CompletionMessageComment__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function CompletionMessageComment__id$_get_name_$ref_9ax52c() {
  return (p0) => p0.k20();
}
function CompletionMessageComment__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment__id$_get_serializer_$ref_9cpr5p() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function CompletionMessageComment__id$_get_annotations_$ref_a9ywih() {
  return (p0) => p0.bz();
}
var CompletionMessageComment__idClass;
function CompletionMessageComment__id() {
  if (CompletionMessageComment__idClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment__id_instance = this;
        var tmp = this;
        tmp.k5e_1 = lazy(CompletionMessageComment__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l5e_1 = lazy(CompletionMessageComment__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m5e_1 = lazy(CompletionMessageComment__id$annotations$delegate$lambda);
        this.n5e_1 = Companion_getInstance_0().m2p();
        this.o5e_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.k5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment__id$_get_name_$ref_9ax52c(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.p5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      z5d(receiver, value) {
        return receiver.a5e(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.z5d(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment__id$_get_serializer_$ref_9cpr5p(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment__id$_get_annotations_$ref_a9ywih(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment__id', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment__idClass = $;
  }
  return CompletionMessageComment__idClass;
}
var CompletionMessageComment__id_instance;
function CompletionMessageComment__id_getInstance() {
  if (CompletionMessageComment__id_instance === VOID)
    new (CompletionMessageComment__id())();
  return CompletionMessageComment__id_instance;
}
function CompletionMessageComment_completionMessage$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function CompletionMessageComment_completionMessage$_get_name_$ref_36uppv() {
  return (p0) => p0.k20();
}
function CompletionMessageComment_completionMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment_completionMessage$_get_serializer_$ref_fe6u2c() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment_completionMessage$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function CompletionMessageComment_completionMessage$_get_annotations_$ref_3w7faw() {
  return (p0) => p0.bz();
}
var CompletionMessageComment_completionMessageClass;
function CompletionMessageComment_completionMessage() {
  if (CompletionMessageComment_completionMessageClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment_completionMessage_instance = this;
        var tmp = this;
        tmp.p5e_1 = lazy(CompletionMessageComment_completionMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q5e_1 = lazy(CompletionMessageComment_completionMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r5e_1 = lazy(CompletionMessageComment_completionMessage$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.p5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment_completionMessage$_get_name_$ref_36uppv(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.q5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      z5d(receiver, value) {
        return receiver.a5e(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.z5d(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment_completionMessage$_get_serializer_$ref_fe6u2c(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment_completionMessage$_get_annotations_$ref_3w7faw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment_completionMessage', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment_completionMessageClass = $;
  }
  return CompletionMessageComment_completionMessageClass;
}
var CompletionMessageComment_completionMessage_instance;
function CompletionMessageComment_completionMessage_getInstance() {
  if (CompletionMessageComment_completionMessage_instance === VOID)
    new (CompletionMessageComment_completionMessage())();
  return CompletionMessageComment_completionMessage_instance;
}
function CompletionMessageComment_sender$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function CompletionMessageComment_sender$_get_name_$ref_we6nh() {
  return (p0) => p0.k20();
}
function CompletionMessageComment_sender$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment_sender$_get_serializer_$ref_n8wrjg() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment_sender$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function CompletionMessageComment_sender$_get_annotations_$ref_5qlwiw() {
  return (p0) => p0.bz();
}
var CompletionMessageComment_senderClass;
function CompletionMessageComment_sender() {
  if (CompletionMessageComment_senderClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment_sender_instance = this;
        var tmp = this;
        tmp.s5e_1 = lazy(CompletionMessageComment_sender$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t5e_1 = lazy(CompletionMessageComment_sender$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u5e_1 = lazy(CompletionMessageComment_sender$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.s5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment_sender$_get_name_$ref_we6nh(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.t5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      z5d(receiver, value) {
        return receiver.a5e(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.z5d(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.t5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment_sender$_get_serializer_$ref_n8wrjg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment_sender$_get_annotations_$ref_5qlwiw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment_sender', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment_senderClass = $;
  }
  return CompletionMessageComment_senderClass;
}
var CompletionMessageComment_sender_instance;
function CompletionMessageComment_sender_getInstance() {
  if (CompletionMessageComment_sender_instance === VOID)
    new (CompletionMessageComment_sender())();
  return CompletionMessageComment_sender_instance;
}
function CompletionMessageComment_senderName$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function CompletionMessageComment_senderName$_get_name_$ref_t7gwfs() {
  return (p0) => p0.k20();
}
function CompletionMessageComment_senderName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment_senderName$_get_serializer_$ref_njq36p() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment_senderName$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function CompletionMessageComment_senderName$_get_annotations_$ref_3kn4hv() {
  return (p0) => p0.bz();
}
var CompletionMessageComment_senderNameClass;
function CompletionMessageComment_senderName() {
  if (CompletionMessageComment_senderNameClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment_senderName_instance = this;
        var tmp = this;
        tmp.v5e_1 = lazy(CompletionMessageComment_senderName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w5e_1 = lazy(CompletionMessageComment_senderName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x5e_1 = lazy(CompletionMessageComment_senderName$annotations$delegate$lambda);
        this.y5e_1 = '';
        this.z5e_1 = '""';
      }
      k20() {
        var tmp0 = this.v5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment_senderName$_get_name_$ref_t7gwfs(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.u5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      a5f(receiver, value) {
        return receiver.a5e(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.a5f(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.w5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment_senderName$_get_serializer_$ref_njq36p(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x5e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment_senderName$_get_annotations_$ref_3kn4hv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment_senderName', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment_senderNameClass = $;
  }
  return CompletionMessageComment_senderNameClass;
}
var CompletionMessageComment_senderName_instance;
function CompletionMessageComment_senderName_getInstance() {
  if (CompletionMessageComment_senderName_instance === VOID)
    new (CompletionMessageComment_senderName())();
  return CompletionMessageComment_senderName_instance;
}
function CompletionMessageComment_clientMessage$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function CompletionMessageComment_clientMessage$_get_name_$ref_w8prky() {
  return (p0) => p0.k20();
}
function CompletionMessageComment_clientMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment_clientMessage$_get_serializer_$ref_yoik79() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment_clientMessage$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function CompletionMessageComment_clientMessage$_get_annotations_$ref_pqzn4n() {
  return (p0) => p0.bz();
}
var CompletionMessageComment_clientMessageClass;
function CompletionMessageComment_clientMessage() {
  if (CompletionMessageComment_clientMessageClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment_clientMessage_instance = this;
        var tmp = this;
        tmp.b5f_1 = lazy(CompletionMessageComment_clientMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c5f_1 = lazy(CompletionMessageComment_clientMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d5f_1 = lazy(CompletionMessageComment_clientMessage$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.b5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment_clientMessage$_get_name_$ref_w8prky(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.v5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      e5f(receiver, value) {
        return receiver.a5e(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.e5f(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment_clientMessage$_get_serializer_$ref_yoik79(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment_clientMessage$_get_annotations_$ref_pqzn4n(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment_clientMessage', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment_clientMessageClass = $;
  }
  return CompletionMessageComment_clientMessageClass;
}
var CompletionMessageComment_clientMessage_instance;
function CompletionMessageComment_clientMessage_getInstance() {
  if (CompletionMessageComment_clientMessage_instance === VOID)
    new (CompletionMessageComment_clientMessage())();
  return CompletionMessageComment_clientMessage_instance;
}
function CompletionMessageComment_message$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function CompletionMessageComment_message$_get_name_$ref_o0du2x() {
  return (p0) => p0.k20();
}
function CompletionMessageComment_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment_message$_get_serializer_$ref_8bmp68() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment_message$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function CompletionMessageComment_message$_get_annotations_$ref_a07h10() {
  return (p0) => p0.bz();
}
var CompletionMessageComment_messageClass;
function CompletionMessageComment_message() {
  if (CompletionMessageComment_messageClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment_message_instance = this;
        var tmp = this;
        tmp.f5f_1 = lazy(CompletionMessageComment_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g5f_1 = lazy(CompletionMessageComment_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h5f_1 = lazy(CompletionMessageComment_message$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.f5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment_message$_get_name_$ref_o0du2x(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.w5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      a5f(receiver, value) {
        return receiver.a5e(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.a5f(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment_message$_get_serializer_$ref_8bmp68(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment_message$_get_annotations_$ref_a07h10(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment_message', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment_messageClass = $;
  }
  return CompletionMessageComment_messageClass;
}
var CompletionMessageComment_message_instance;
function CompletionMessageComment_message_getInstance() {
  if (CompletionMessageComment_message_instance === VOID)
    new (CompletionMessageComment_message())();
  return CompletionMessageComment_message_instance;
}
function CompletionMessageComment_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function CompletionMessageComment_readBy$_get_name_$ref_q0841x() {
  return (p0) => p0.k20();
}
function CompletionMessageComment_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionMessageComment_readBy$_get_serializer_$ref_5av8q4() {
  return (p0) => p0.j2j();
}
function CompletionMessageComment_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function CompletionMessageComment_readBy$_get_annotations_$ref_wmqkxc() {
  return (p0) => p0.bz();
}
var CompletionMessageComment_readByClass;
function CompletionMessageComment_readBy() {
  if (CompletionMessageComment_readByClass === VOID) {
    class $ {
      constructor() {
        CompletionMessageComment_readBy_instance = this;
        var tmp = this;
        tmp.i5f_1 = lazy(CompletionMessageComment_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j5f_1 = lazy(CompletionMessageComment_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k5f_1 = lazy(CompletionMessageComment_readBy$annotations$delegate$lambda);
        this.l5f_1 = emptySet();
        this.m5f_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.i5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionMessageComment_readBy$_get_name_$ref_q0841x(), null);
        return tmp0.f2();
      }
      o5d(receiver) {
        return receiver.x5d_1;
      }
      m2j(receiver) {
        return this.o5d(receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE());
      }
      n5f(receiver, value) {
        return receiver.a5e(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionMessageComment() ? receiver : THROW_CCE();
        return this.n5f(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionMessageComment_readBy$_get_serializer_$ref_5av8q4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k5f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionMessageComment_readBy$_get_annotations_$ref_wmqkxc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionMessageComment_readBy', VOID, VOID, [SerializableProperty()]);
    CompletionMessageComment_readByClass = $;
  }
  return CompletionMessageComment_readByClass;
}
var CompletionMessageComment_readBy_instance;
function CompletionMessageComment_readBy_getInstance() {
  if (CompletionMessageComment_readBy_instance === VOID)
    new (CompletionMessageComment_readBy())();
  return CompletionMessageComment_readBy_instance;
}
//region block: exports
export {
  get_created as get_created278y0y3t5m41w,
  get_lineItem as get_lineItem18mpd576lf2v8,
  prepareCompletionMessageCommentFields as prepareCompletionMessageCommentFields3ed6d955pfr4z,
  get_project as get_project2fucttg0o5hjg,
};
//endregion

//# sourceMappingURL=CompletionMessageCommentFields.mjs.map
